// extracted by mini-css-extract-plugin
export default {"Container":"Search_Container__vwrYW","SearchIcon":"Search_SearchIcon__p-a51"};